<div class="loading-text" [class]="mode" role="status" aria-atomic="true">
    <div class="dot-flashing"></div>
    <span [innerHTML]="text | translate | safeStyle"></span>
</div>
